import { render, staticRenderFns } from "./AlertRule.vue?vue&type=template&id=e8ad2778&scoped=true"
import script from "./AlertRule.vue?vue&type=script&lang=js"
export * from "./AlertRule.vue?vue&type=script&lang=js"
import style0 from "./AlertRule.vue?vue&type=style&index=0&id=e8ad2778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ad2778",
  null
  
)

export default component.exports